import React, { useState } from "react";
import "./createpackagedialog.css";

export default function CreatePackageDialog({
  open,
  onClose,
  onSubmit,
  isLoading = false
}) {
  const [formData, setFormData] = useState({
    name: "",
    destination: "",
    duration_days: 1,
    category: "Honeymoon",
    description: "",
    price_per_person: 0,
    image_url: ""
  });

  if (!open) return null;

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <div className="modal-header">
          <h2>Create New Package</h2>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          <div className="form-grid">
            <div className="full">
              <label>Package Name *</label>
              <input
                value={formData.name}
                onChange={(e) => handleChange("name", e.target.value)}
                placeholder="Romantic Bali Getaway"
                required
              />
            </div>

            <div>
              <label>Destination *</label>
              <input
                value={formData.destination}
                onChange={(e) => handleChange("destination", e.target.value)}
                required
              />
            </div>

            <div>
              <label>Duration (days) *</label>
              <input
                type="number"
                min="1"
                value={formData.duration_days}
                onChange={(e) =>
                  handleChange("duration_days", Number(e.target.value))
                }
                required
              />
            </div>

            <div>
              <label>Category *</label>
              <select
                value={formData.category}
                onChange={(e) => handleChange("category", e.target.value)}
              >
                <option>Honeymoon</option>
                <option>Adventure</option>
                <option>Luxury</option>
                <option>Family</option>
                <option>Business</option>
                <option>Group Tour</option>
                <option>Solo Travel</option>
                <option>Pilgrimage</option>
              </select>
            </div>

            <div>
              <label>Price per Person *</label>
              <input
                type="number"
                min="0"
                step="0.01"
                value={formData.price_per_person}
                onChange={(e) =>
                  handleChange("price_per_person", Number(e.target.value))
                }
                required
              />
            </div>

            <div className="full">
              <label>Image URL</label>
              <input
                value={formData.image_url}
                onChange={(e) => handleChange("image_url", e.target.value)}
                placeholder="https://images.unsplash.com/..."
              />
            </div>
          </div>

          <div>
            <label>Description</label>
            <textarea
              rows="4"
              value={formData.description}
              onChange={(e) => handleChange("description", e.target.value)}
              placeholder="Describe the package..."
            />
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="outline-btn"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="primary-btn"
              disabled={isLoading}
            >
              {isLoading ? "Creating..." : "Create Package"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
